const data = {
  item: [
    {
    "name": "Ready, Combo, Go!",
    "slug": "ready-combo-go",
    "category": "Cat and Dog box",
    "image": "https://res.cloudinary.com/dtfbwnsv7/image/upload/v1686846877/cat_dog_zpqe6t.png", 
    "price": 20.99,
    "countInStock": 10,
    "brand": "Ready Pet Go",
    "rating": 5,
    "numReviews": 10,
    "description": "Perfect for cat AND dog parents. Spoil your two animals with ONE box! Includes: Treats for each, specialized toys for each animal, a toy both animals will love, a collar, and leash! Every box includes tips & tricks to help you care for your animals."
    }
  ]
}

export default data;